import React from 'react';
import PropTypes from 'prop-types';
import { Box, FormControl } from '@mui/material';
import { Range } from 'react-range';
import { COLOR_CARNATION, COLOR_DENIM, COLOR_LIGHT_GREY, FONT_SIZE_16_PX } from 'popTheme';

const ExtremeEndLabels = ({ startLabel, endLabel, hideOnMobile }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      pt: '1.5rem',
      width: 'inherit',
      height: 'fit-content',
      fontWeight: 600,
      fontSize: FONT_SIZE_16_PX,
      color: COLOR_DENIM,
      marginBlockStart: '1.5rem',
      marginInline: 'auto',
      paddingInline: 'inherit',
      boxSizing: 'border-box',

      '@media screen and (max-width: 768px)': {
        display: hideOnMobile ? 'none' : 'flex',
      },
    }}
  >
    <span>{startLabel}</span>
    <span>{endLabel}</span>
  </Box>
);

const MemoizedRange = React.memo(Range);

export const SlidingScale = ({ thumbPosition, startLabel, endLabel, onChange }) => {
  const disabled = !Number.isFinite(thumbPosition);
  const values = [Number.isFinite(thumbPosition) ? thumbPosition : 0];
  const notifyParent = (values) => onChange(values[0]);
  const doNothing = () => null;
  const notify_for_first_interaction_only = disabled ? notifyParent : doNothing;

  function renderTrack({ props, children }) {
    const style = {
      ...props.style,
      width: 'inherit',
      border: `0.25rem solid ${disabled ? COLOR_LIGHT_GREY : COLOR_CARNATION}`,
      marginInline: 'auto',
      marginBlock: '1.5rem',
    };
    return (
      <Box {...props} role="presentation" style={style}>
        {children}
      </Box>
    );
  }

  function renderThumb({ props }) {
    const style = {
      ...props.style,
      height: '0.75rem',
      width: '0.75rem',
      border: `0.375rem solid ${disabled ? COLOR_LIGHT_GREY : COLOR_CARNATION}`,
      borderRadius: '0.1875rem',
      background: `${disabled ? COLOR_LIGHT_GREY : COLOR_CARNATION}`,
    };
    return <Box {...props} style={style} />;
  }

  function renderMark({ props, index }) {
    const style = {
      ...props.style,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0rem',
      alignSelf: 'stretch',
      marginTop: '1.5rem',
    };
    return (
      <Box {...props} style={style}>
        {index}
      </Box>
    );
  }

  return (
    <FormControl sx={{ width: { xs: '90%', sm: '75%' } }}>
      <MemoizedRange
        role="slider"
        values={values}
        onChange={notifyParent}
        onFinalChange={notify_for_first_interaction_only}
        min={0}
        max={10}
        step={1}
        draggableTrack={false}
        renderTrack={renderTrack}
        renderThumb={renderThumb}
        renderMark={renderMark}
      />
      <ExtremeEndLabels startLabel={startLabel} endLabel={endLabel} hideOnMobile={false} />
    </FormControl>
  );
};

ExtremeEndLabels.defaultProps = {
  hideOnMobile: false,
};

ExtremeEndLabels.propTypes = {
  startLabel: PropTypes.string.isRequired,
  endLabel: PropTypes.string.isRequired,
  hideOnMobile: PropTypes.bool,
};

SlidingScale.propTypes = {
  startLabel: PropTypes.string.isRequired,
  endLabel: PropTypes.string.isRequired,
};
